enum Role {
  SUPER = 'SUPER',
  ADMIN = 'ADMIN',
  CONTROLLERSHIP = 'CONTROLADORIA',
  SHARED = 'SHARED',
}

export default Role;
